export const localizeDate = (date: Date) => {
  const localeDate = new Date(date).toLocaleDateString('ru', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return localeDate.split(' ').slice(0, -1).join(' ');
};
